import { GraphqlError } from 'core/utils/backend-service';
import { DeviceTypeDetails } from 'modules/devices/domain/api/device-type.api';
import { DeviceConfigurationInfo } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-configuration-list/settings-devices-configuration-list.model';
import { createContext, Dispatch, SetStateAction } from 'react';

export interface RefreshInterfaceConfigProps {
    fetchingDelay: number;
}

export interface ConfigurationListContextType {
    selectedTab: string;
    deviceTypeSelected: DeviceTypeDetails | undefined;
    isLoading: boolean;
    configurations: DeviceConfigurationInfo[];
    error?: GraphqlError;
    selectedRows: DeviceConfigurationInfo[];
    showOnlyActiveConfigs: boolean;
    configurationSelected?: DeviceConfigurationInfo;
    refreshConfigurationList: (config?: RefreshInterfaceConfigProps) => Promise<void>;
    setSelectedTab: (tab: string) => void;
    setConfigurationSelected: Dispatch<SetStateAction<DeviceConfigurationInfo | undefined>>;
    setSelectedRows: Dispatch<SetStateAction<DeviceConfigurationInfo[]>>;
    setShowOnlyActiveConfig: Dispatch<SetStateAction<boolean>>;
}

export const ConfigurationListContext = createContext<ConfigurationListContextType | undefined>(undefined);
